export enum SwarmType {
	MA = "MA",
	FUNDING = "FUNDING",
}

export enum FundingRounds {
	GRANT = "grant",
	PRE_SEED = "pre-seed",
	SEED = "seed",
	SERIES_A = "series-a",
	SERIES_B = "series-b",
	SERIES_C = "series-c",
	SERIES_D = "series-d",
	OTHER = "other",
}

export const FundingRoundsValues = [
	{
		id: FundingRounds.GRANT,
		title: "Grant",
	},
	{
		id: FundingRounds.PRE_SEED,
		title: "Pre-Seed",
	},
	{
		id: FundingRounds.SEED,
		title: "Seed",
	},
	{
		id: FundingRounds.SERIES_A,
		title: "Series A",
	},
	{
		id: FundingRounds.SERIES_B,
		title: "Series B",
	},
	{
		id: FundingRounds.SERIES_C,
		title: "Series C",
	},
	{
		id: FundingRounds.SERIES_D,
		title: "Series D",
	},
	{
		id: FundingRounds.OTHER,
		title: "Other",
	},
];

export const FundingCountries = [
	"United States",
	"China",
	"Japan",
	"Germany",
	"United Kingdom",
	"India",
	"France",
	"Canada",
	"Italy",
	"South Korea",
	"Australia",
	"Brazil",
	"Spain",
	"Mexico",
	"Indonesia",
	"Netherlands",
	"Saudi Arabia",
	"Turkey",
	"Switzerland",
	"Taiwan",
	"Poland",
	"Sweden",
	"Belgium",
	"Thailand",
	"Argentina",
	"Nigeria",
	"Austria",
	"Iran",
	"Norway",
	"United Arab Emirates",
	"Ireland",
	"Israel",
	"South Africa",
	"Denmark",
	"Singapore",
	"Malaysia",
	"Philippines",
	"Hong Kong",
	"Colombia",
	"Bangladesh",
	"Egypt",
	"Finland",
	"Chile",
	"Vietnam",
	"Czechia",
	"Romania",
	"New Zealand",
	"Portugal",
	"Greece",
	"Iraq",
	"Qatar",
	"Peru",
	"Hungary",
	"Kuwait",
	"Ukraine",
	"Morocco",
	"Slovakia",
	"Puerto Rico",
	"Ecuador",
	"Oman",
	"Kenya",
	"Luxembourg",
	"Cuba",
	"Sri Lanka",
	"Uzbekistan",
	"Bulgaria",
	"Croatia",
	"Côte d'Ivoire",
	"Belarus",
	"Uruguay",
	"Panama",
	"Slovenia",
	"Turkmenistan",
	"Lithuania",
	"Lebanon",
	"Tanzania",
	"Jordan",
	"Bahrain",
	"Serbia",
	"Cameroon",
	"Bolivia",
	"Paraguay",
	"Ghana",
	"Estonia",
	"Uganda",
	"Zambia",
	"Afghanistan",
	"Bosnia and Herzegovina",
	"Mozambique",
	"Armenia",
	"Georgia",
	"Honduras",
	"Albania",
	"Madagascar",
	"Namibia",
	"Senegal",
	"Malta",
	"Chad",
	"Niger",
	"Mali",
	"Kyrgyzstan",
	"Malawi",
	"Rwanda",
	"Burundi",
	"Comoros",
	"Lesotho",
	"Tajikistan",
	"Suriname",
	"Montenegro",
	"Eswatini",
	"Sierra Leone",
	"Gambia",
	"Guyana",
	"Timor-Leste",
	"Mauritania",
	"Burkina Faso",
	"Liberia",
	"Cape Verde",
	"Mauritius",
	"Bhutan",
	"Benin",
	"Central African Republic",
	"Togo",
	"Guinea",
	"Gabon",
	"São Tomé and Príncipe",
	"Equatorial Guinea",
	"Antigua and Barbuda",
	"Belize",
	"Barbados",
	"Saint Kitts and Nevis",
	"Vanuatu",
	"Solomon Islands",
	"Saint Vincent and the Grenadines",
	"Fiji",
	"Samoa",
	"Tonga",
	"Dominica",
	"Russia",
];

export const FundingCategories = {
	AI: [
		"AI-based Skills Intelligence",
		"AI/Machine Learning",
		"AI/Software",
		"Automation",
		"Conversational AI and Automation Platform",
		"Technology/AI",
		"Technology/Automation",
	],
	Marketing: [
		"Advertising",
		"Advertising & Marketing",
		"Advertising/Marketing",
		"Branding & Design",
		"Creative",
		"Digital Marketing Agency",
		"Marketing",
		"Marketing and Communications",
		"Marketing and PR",
		"Marketing/Advertising",
		"Marketing Services",
		"Public Relations and Communications Services",
	],
	"Aerospace & Defense": [
		"Aerospace",
		"Aerospace/Defense",
		"Defense",
		"Space Resources",
		"Space Technology",
		"Space Transportation",
		"Spacecraft",
		"Space Research and Technology",
		"Defense and Space Manufacturing",
	],
	Agriculture: [
		"AgriTech",
		"Agriculture",
		"Food & Agriculture",
		"Food and Agriculture",
		"Forestry",
		"Food and Beverage Manufacturing",
		"Food and Beverage Services",
		"Agriculture, Construction, Mining Machinery Manufacturing",
	],
	Analytics: [
		"Analytics",
		"Analytics and Relationship Intelligence",
		"Business Analytics",
		"Business Intelligence",
		"Data Governance",
		"Data Management",
		"Data Platform",
		"Data Quality Management",
		"Enterprise Analytics",
		"Sports Analytics",
	],
	Architecture: [
		"Architecture",
		"Architecture and Interior Design Software",
		"Art and Architecture",
		"Interior Design",
	],
	Arts: [
		"Arts & Culture",
		"Arts & Entertainment",
		"Film and Storytelling",
		"Music",
		"Music Education",
		"Music Industry",
		"Music and Technology",
		"Museums, Historical Sites, and Zoos",
		"Artists and Writers",
		"Movies, Videos, and Sound",
	],
	FinTech: [
		"Banking",
		"Banking and Accounting",
		"Banking and Credit Union",
		"Credit Technology",
		"Finance",
		"Finance/Investment",
		"Finance/Technology",
		"Financial Management Software",
		"Financial Services",
		"Financial Technology",
		"FinTech",
	],
	"Battery Technology": [
		"Battery Cell Solutions",
		"Battery Manufacturing",
		"Battery Materials",
		"Battery Materials Supplier",
		"Battery Recycling",
		"Battery Technology",
	],
	Cosmetics: ["Beauty", "Beauty & Personal Care", "Beauty and Personal Care", "Cosmetics"],
	Biotechnology: [
		"Biopharmaceutical",
		"Biopharmaceuticals",
		"Biosciences",
		"Biotech",
		"Biotechnological Solutions",
		"Biotechnology",
		"Pharmaceutical",
		"Pharmaceutical Industry",
		"Pharmaceuticals",
		"Biotechnology Research",
		"Pharmaceutical Manufacturing",
	],
	Web3: [
		"Blockchain",
		"Blockchain Compute",
		"Blockchain Technology",
		"Blockchain/Technology",
		"Crypto Investment",
		"Cryptocurrency",
		"DeFi Infrastructure",
		"Gaming/Blockchain",
		"Blockchain Services",
	],
	Construction: [
		"Construction",
		"Construction Automation",
		"Construction Management",
		"Construction Materials",
		"Construction Safety System",
		"Construction and Engineering",
		"Construction and Logistics",
		"Construction/Building Materials",
		"Construction/Environmental Services",
		"Construction/Roofing",
	],
	Sports: [
		"Sports",
		"Sports and Recreation Instruction",
		"Sports & Recreation",
		"Sports/Recreation",
		"Sports and Innovation",
		"Sports Research",
		"Sports Technology",
		"Sports Solutions",
		"Sports & Entertainment",
		"Sports Marketing",
	],
	Retail: [
		"Beauty & Personal Care",
		"Beverage",
		"Beverages",
		"Fashion",
		"Apparel & Fashion",
		"Fashion Industry",
		"Food & Beverage",
		"Food & Beverages",
		"Food & Drink",
		"Food Delivery",
		"Food and Beverage Retail",
		"Furniture",
		"Grocery Delivery",
		"Retail",
		"Retail Ecommerce",
		"Retail Technology",
		"Retail/Toys",
		"Toys",
		"Retail Apparel and Fashion",
		"Retail Health and Personal Care Products",
		"Wholesale Food and Beverage",
		"Retail Office Equipment",
		"Retail Luxury Goods and Jewelry",
		"Consumer Goods",
		"Retail Recyclable Materials & Used Merchandise",
	],
	Cybersecurity: [
		"Cybersecurity",
		"Data Protection",
		"Enterprise Cybersecurity",
		"Security",
		"Security Analytics",
		"Technology/Security",
	],
	"E-commerce": [
		"E-commerce",
		"E-commerce Analytics",
		"Ecommerce",
		"Online ordering app",
		"Technology/E-commerce",
		"Technology/eCommerce",
	],
	Education: [
		"Education",
		"Education & Recruitment",
		"Education/Training",
		"E-Learning Providers",
		"Online Learning",
		"Training",
		"Primary and Secondary Education",
		"Professional Training and Coaching",
		"Higher Education",
		"Education Administration Programs",
		"Education Management",
	],
	Energy: [
		"Clean Energy",
		"Clean Energy Technology",
		"Climate Change",
		"Climate Risk Data Analytics",
		"Climate Solutions",
		"Energy",
		"Energy & Cleantech",
		"Energy & Sustainability",
		"Energy Industry",
		"Energy Management",
		"Energy Renovation",
		"Energy Storage",
		"Energy Storage Solutions",
		"Renewable Energy",
		"Sustainability",
		"Sustainable Innovation",
		"Services for Renewable Energy",
		"Renewable Energy Power Generation",
		"Renewable Energy Semiconductor Manufacturing",
		"Solar Electric Power Generation",
		"Renewables & Environment",
		"Renewable Energy Equipment Manufacturing",
		"Packaging and Containers Manufacturing",
	],
	"Environmental Services": [
		"Chemical and Environmental Industry",
		"Environmental Data Network",
		"Environmental Education",
		"Environmental Management",
		"Environmental Research",
		"Environmental Services",
		"Water and Energy",
		"Environmental Services",
	],
	Healthcare: [
		"Animal Health",
		"Health",
		"Health, Wellness & Fitness",
		"Health Care Provider and Insurer",
		"Health Insurance",
		"Health Monitoring",
		"Health and Fitness",
		"Health and Wellness",
		"Healthcare",
		"Healthcare Data Solutions",
		"Healthcare Management Software",
		"Healthcare Revenue Cycle Management Software",
		"Healthcare Technology",
		"Healthcare Travel Jobs Platform",
		"Healthcare and Life Sciences",
		"Healthcare and Life Sciences Investment Firm",
		"Healthcare/ Mental Health Services",
		"Hospitals and Health Care",
		"Medical Practices",
		"Medical",
		"Medical Devices",
		"Medical Diagnostic Applications",
		"Medical Imaging",
		"Medical Solutions",
		"Medical Technology",
		"Medical Transport",
		"Medical imaging",
		"Medical/Robotics",
		"Mental Health",
		"Pediatrics",
		"Pharmacy",
		"Veterinary",
		"Veterinary Medicine",
		"Medical Device",
		"Medical Equipment Manufacturing",
		"Wellness and Fitness Services",
		"Home Health Care Services",
		"Mental Health Care",
	],
	Manufacturing: [
		"Industrial",
		"Industrial Automation",
		"Industrial Equipment",
		"Industrial Platform",
		"Industrial Solutions",
		"Industrial Supplies",
		"Manufacturing",
		"Manufacturing/Engineering",
		"Manufacturing/Industrial",
		"Manufacturing/Technology",
		"Appliances, Electrical, and Electronics Manufacturing",
		"Paper and Forest Product Manufacturing",
		"Electrical Equipment Manufacturing",
		"HVAC and Refrigeration Equipment Manufacturing",
		"Industrial Machinery Manufacturing",
		"Furniture and Home Furnishings Manufacturing",
	],
	Software: [
		"API Development",
		"App",
		"Business Services",
		"Cloud Computing",
		"Cloud Data Protection",
		"Cloud Governance",
		"Cloud Security",
		"Cloud-based file storage and sharing",
		"Customer Service Software and Sales CRM",
		"Document Management",
		"Enterprise Software",
		"IT and Technology",
		"IT/Software Development",
		"Software",
		"Software Development",
		"Software Testing",
		"Software Testing Automation",
		"Software/Technology",
		"Technology/Data Center Development",
		"Technology/Data Centers",
		"Technology/Enterprise Transformation",
		"Technology, Information and Media",
		"Technology/IT",
		"Technology/Software",
		"Technology/Software Development",
		"Technology/Software Engineering",
		"IT Services and IT Consulting",
		"Information Technology & Services",
		"Technology, Information and Internet",
		"Data Infrastructure and Analytics",
		"Mobile Computing Software Products",
		"IT System Custom Software Development",
		"Desktop Computing Software Products",
		"Computer Software",
		"Computer and Network Security",
		"Embedded Software Products",
		"Computer Games",
		"Social Networking Platforms",
		"Internet Marketplace Platforms",
		"Computer & Network Security",
	],
	Logistics: [
		"Autonomous Vehicles and Transportation",
		"Aviation",
		"Aviation Management",
		"Aviation Software Solutions",
		"Logistics",
		"Logistics/Postal Services",
		"Shipping and Logistics",
		"Transportation",
		"Transportation and Logistics",
		"Transportation/Logistics",
		"Travel and Transportation",
		"Transportation, Logistics, Supply Chain and Storage",
		"Motor Vehicle Manufacturing",
	],
	Media: [
		"Comics Creation and Reader App",
		"Digital Media Solutions",
		"Media",
		"Media/Advertising",
		"Media Production",
		"Spectator Sports",
		"Media/Content Marketing",
		"Publishing",
		"Advertising Services",
		"Broadcast Media Production and Distribution",
		"Writing and Editing",
	],
	"Non-profit": [
		"Charity/Non-profit organization",
		"Community Services",
		"Non-profit organization",
		"Non-profit/Charity",
		"Nonprofit Organization",
		"Religious Organization",
		"Social Enterprise",
		"Social Services",
		"Non-profit Organizations",
		"Non-profit Organization Management",
	],
	"Real Estate": [
		"Architecture and Interior Design Software",
		"Home Decor",
		"Home Improvement",
		"Home Improvement and Maintenance",
		"Home Services",
		"Property Development Software",
		"Property Registration",
		"Real Estate",
		"Civic and Social Organizations",
		"Leasing Residential Real Estate",
		"Architecture and Planning",
	],
	Robotics: [
		"Automation",
		"Construction Automation",
		"Industrial Automation",
		"Robotics",
		"Technology/Robotics",
	],
	Science: [
		"Information & Communication Systems",
		"Information Retrieval and feature engineering",
		"Information Technology",
		"Machine Identity Management",
		"Machine Learning",
		"Quantum Technology",
		"Science and Technology",
		"Technology",
		"Technology/Analytics",
		"Technology/Artificial Intelligence",
		"Technology/Audio",
		"Technology/Computation",
		"Technology/Computing",
		"Technology/Decentralized",
		"Technology/Emerging Technologies",
		"Technology/Enterprise Transformation",
		"Technology/Internet of Things",
		"Technology/Quantum",
		"Technology/Quantum Computing",
		"Technology/Quantum Hardware",
		"Computer Hardware Manufacturing",
		"Technology/Research",
		"Technology/Sensor Systems",
		"Technology/Sensors",
		"Technology/Wildfire Solutions",
		"Automation Machinery Manufacturing",
		"Aviation and Aerospace Component Manufacturing",
	],
	Telecommunications: [
		"Telecommunications",
		"Technology/Communication",
		"Technology/Internet Connectivity",
		"Technology/Telecommunications",
		"Wireless Internet Services",
	],
	Travel: [
		"Adventures",
		"Hospitality",
		"Hospitality and Travel",
		"Travel",
		"Travel and Finance",
		"Travel and Lifestyle Accessories",
		"Travel and Tourism",
	],
	"VC & Investment": [
		"Business incubator",
		"Entrepreneurship",
		"Entrepreneurship and Innovation",
		"Investment",
		"Investment Fund",
		"Technology/Accelerator",
		"Technology/Accelerator Program",
		"Technology/Accelerators",
		"Technology/Incubation",
		"Technology/Incubator",
		"Technology/Investment",
		"Venture Capital",
		"Venture Capital and Startup Ecosystem",
		"Venture Firm",
		"Business Intelligence Platforms",
		"Venture Capital and Private Equity Principals",
		"VC & Investment",
		"Business Consulting and Services",
		"Investment Management",
		"Philanthropic Fundraising Services",
	],
};

export enum MaStatus {
	ANNOUNCED = "ANNOUNCED",
	COMPLETED = "COMPLETED",
	PENDING = "PENDING",
}

export const MaStatusValues = [
	{
		id: MaStatus.ANNOUNCED,
		title: "Announced",
	},
	{
		id: MaStatus.COMPLETED,
		title: "Completed",
	},
	{
		id: MaStatus.PENDING,
		title: "Pending",
	},
];
